module.exports = __webpack_public_path__ + "img/omold.cdf2cd9b.svg";